import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Languages } from "lucide-react";

const Header = () => {
  const { lang, toggleLang, t } = useLanguage();
  const location = useLocation();

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <header
      className="sticky top-0 z-50 bg-[#FAFAF9]/80 backdrop-blur-xl border-b border-[rgba(117,148,122,0.1)]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="logo-link"
        >
          <img
            src="/images/ericeira-works-logo.webp"
            alt="Ericeira Works"
            className="h-16 w-auto object-contain -my-4 -ml-4"
            style={{ mixBlendMode: "multiply" }}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link
            to="/freelancers"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              isActive("/freelancers")
                ? "bg-[#E6EDE7] text-[#202C21]"
                : "text-[#5C6B5D] hover:bg-[#E6EDE7] hover:text-[#202C21]"
            }`}
            data-testid="nav-freelancers"
          >
            {t.nav.freelancers}
          </Link>
          <a
            href="/#about"
            className="px-4 py-2 rounded-full text-sm font-medium text-[#5C6B5D] hover:bg-[#E6EDE7] hover:text-[#202C21] transition-colors"
            data-testid="nav-about"
          >
            {t.nav.about}
          </a>
          <a
            href="/#project-form"
            className="px-4 py-2 rounded-full text-sm font-medium text-[#5C6B5D] hover:bg-[#E6EDE7] hover:text-[#202C21] transition-colors"
            data-testid="nav-project"
          >
            {t.nav.project}
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={toggleLang}
            className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] px-3 py-2 rounded-full border border-[rgba(117,148,122,0.25)] text-[#5C6B5D] hover:border-[#75947A] hover:text-[#202C21] transition-colors"
            data-testid="language-toggle"
            aria-label="Toggle language"
          >
            <Languages className="w-3.5 h-3.5" strokeWidth={1.75} />
            <span>{lang.toUpperCase()}</span>
            <span className="text-[#8A9A8B]">/</span>
            <span className="text-[#8A9A8B]">
              {(lang === "en" ? "pt" : "en").toUpperCase()}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
